import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";


const ResetImage: React.FunctionComponent<{ imageValue: any, onResetImage: any }> = (props) => {

    const [isChangeReset, setIsChangeReset] = useState<boolean>(false);
    const location = useLocation();
    const { t } = useTranslation();


    const ResetHandle = () => {
        setIsChangeReset(true)
        if (!props.imageValue || !props.imageValue.id) {
            console.error('No image selected for reset');
            return;
        }
        props.onResetImage(props.imageValue.id).then(() => {
            setIsChangeReset(false);
        }).catch(() => {
            setIsChangeReset(false);
        });
    }


    return (

        <button className={`button-reset back-trans padd-15 marg-right-16 color-D80027 border-D80027`} onClick={ResetHandle}>
            {t("listingCreation.reset")}
            {isChangeReset && <div className="col-auto marg-left-5">
                <div className="spinner-border text-primary" style={{ width: "20px", height: "20px" }} role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>}
        </button>

    )

}

export default ResetImage;